import { chartSeriesColors } from "@/components/charts/seriesPalette"

/**
 * Color for the `index`-th of `total` compared groups — a distinct categorical
 * hue from the shared series palette (series identity, not a sequential ramp).
 * Wraps if there are more groups than palette colors.
 */
export function getPaletteColor(index: number, total: number): string {
  const colors = chartSeriesColors(Math.max(total, 1))
  const wrapped = ((index % colors.length) + colors.length) % colors.length
  return colors[wrapped]
}

/** Storage key for color overrides: "agent:id", "mutation:id", "persona:id", "test_case:id", "metadata:key\u001Fvalue" */
export const COMPARE_BY_OVERRIDE_PREFIX = {
  agent: "agent:",
  mutation: "mutation:",
  persona: "persona:",
  test_case: "test_case:",
  metadata: "metadata:",
  run: "run:",
  tag: "tag:",
  custom: "custom:",
} as const

/**
 * Build a {groupId → color} map for an ordered list of custom-dimension group ids.
 * Falls back to palette colors; honors any per-group overrides keyed by `custom:<groupId>`.
 */
export function buildCustomDimensionGroupColors(
  groupIds: readonly string[],
  colorOverrides: Record<string, string>,
): Record<string, string> {
  const out: Record<string, string> = {}
  groupIds.forEach((id, i) => {
    const overrideKey = `${COMPARE_BY_OVERRIDE_PREFIX.custom}${id}`
    out[id] = colorOverrides[overrideKey] ?? getPaletteColor(i, groupIds.length)
  })
  return out
}

export const METADATA_KEY_SEP = "\u001F"
